import { PointerEvent } from 'react';

function isEventWithElement(event: PointerEvent): event is PointerEvent & {
    target: Element & { parentElement: Element };
} {
    return !!(event.target && event.target instanceof Element && event.target.parentElement);
}

export function calculateMovePosition(event: PointerEvent) {
    if (!isEventWithElement(event)) return null;
    const parent = event.target.parentElement.getBoundingClientRect();
    const percentage = ((event.clientX - parent.x) / parent.width) * 100;

    // Clamp the range from 0 to 100
    return Math.min(Math.max(percentage, 0), 100);
}
